import { render, staticRenderFns } from "./BaseScreen.vue?vue&type=template&id=d9081f36&"
import script from "./BaseScreen.vue?vue&type=script&lang=ts&"
export * from "./BaseScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports